import React, { useState } from 'react';
import axios from 'axios';
import { AlertCircle, CheckCircle, Loader, User, AtSign, Lock, EyeOff, Eye,X,Menu } from 'lucide-react';
import FooterSection from './components/FooterSection';

export default function RegisterForm() {
  const [formData, setFormData] = useState({
    name: '',
    username: '',
    password: '',
    confirmPassword: ''
  });
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
      isValid = false;
    } else if (formData.name.trim().length < 2) {
      newErrors.name = 'Name must be at least 2 characters long';
      isValid = false;
    }

    // Username validation
    if (!formData.username.trim()) {
      newErrors.username = 'Username is required';
      isValid = false;
    } else if (formData.username.trim().length < 3) {
      newErrors.username = 'Username must be at least 3 characters long';
      isValid = false;
    } else if (!/^[a-zA-Z0-9_]+$/.test(formData.username)) {
      newErrors.username = 'Username can only contain letters, numbers, and underscores';
      isValid = false;
    }

    // Password validation
    if (!formData.password) {
      newErrors.password = 'Password is required';
      isValid = false;
    } else if (formData.password.length < 8) {
      newErrors.password = 'Password must be at least 8 characters long';
      isValid = false;
    } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(formData.password)) {
      newErrors.password = 'Password must contain at least one uppercase letter, one lowercase letter, and one number';
      isValid = false;
    }

    // Confirm password validation
    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await axios.post('https://testone.conversationaily.ai/api/register', {
        name: formData.name,
        username: formData.username,
        password: formData.password
      });
      setMessage(response.data.message);
      setTimeout(() => {
        // Redirect to login page after 2 seconds
        // Note: In a real app, you'd use React Router for navigation
        window.location.href = '/';
      }, 2000);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        setError(error.response.data.message);
      } else {
        setError('An error occurred. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  return (
    <div>
            <nav className="bg-[#D6D1D11A] min-h- h-16 py-4 px-8 rounded-full flex justify-between items-center max-w-screen-xl mx-auto m-4">
  <div className="flex-shrink-0 flex items-center justify-center">
    <img
      className="h-8 w-auto object-contain"
      src="./logo.png"
      alt="Your Company"
      id="logo"
    />
  </div>

  <div className="hidden md:flex space-x-6">
  <a href="#!" className="text-[#30507F] hover:text-blue-700 font-semibold">Home</a>
    <a href="#!" className="text-[#30507F] hover:text-blue-700 font-semibold">About</a>
    <a href="#!" className="text-[#30507F] hover:text-blue-700 font-semibold">Publications</a>
    <a href="#!" className="text-[#30507F] hover:text-blue-700 font-semibold">Expert Panel</a>
    <a href="#!" className="text-[#30507F] hover:text-blue-700 font-semibold">Alliances</a>
    <a href="#!" className="text-[#30507F] hover:text-blue-700 font-semibold">Contact Us</a>
  </div>

  <div className="hidden md:block">
    <a href="/" className="bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-5 py-2 rounded-full font-semibold hover:from-yellow-500 hover:to-orange-600">
      Sign In
    </a>
  </div>

  <div className="md:hidden">
    <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-blue-700">
      {isOpen ? <X size={24} /> : <Menu size={24} />}
    </button>
  </div>

  {isOpen && (
    <div className="absolute top-16 left-0 right-0 bg-white p-4 md:hidden z-10">
      <div className="flex flex-col space-y-4">
      <a href="#!" className="text-[#30507F] hover:text-blue-700 font-semibold">Home</a>
    <a href="#!" className="text-[#30507F] hover:text-blue-700 font-semibold">About</a>
    <a href="#!" className="text-[#30507F] hover:text-blue-700 font-semibold">Publications</a>
    <a href="#!" className="text-[#30507F] hover:text-blue-700 font-semibold">Expert Panel</a>
    <a href="#!" className="text-[#30507F] hover:text-blue-700 font-semibold">Alliances</a>
    <a href="#!" className="text-[#30507F] hover:text-blue-700 font-semibold">Contact Us</a>
        <a href="/" className="bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-5 py-2 rounded-full font-semibold text-center hover:from-yellow-500 hover:to-orange-600">
          Sign In
        </a>
      </div>
    </div>
  )}
</nav>
<div className="min-h-screen bg-gradient-to-br from-purple-100 to-indigo-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-2xl w-full max-w-md overflow-hidden sm:-mt-12 relative">
        <div className="absolute inset-0 bg-cover bg-center z-0" style={{backgroundImage: 'url("/api/placeholder/800/600")', opacity: 0.1}}></div>
        <div className="relative z-10 p-8">
          <div className="mb-8 text-center">
            <div className="w-20 h-20 bg-indigo-100 rounded-full mx-auto mb-4 flex items-center justify-center">
              <User size={40} className="text-indigo-600" />
            </div>
            <h2 className="text-3xl font-bold text-gray-800 mb-2">Create an account</h2>
            <p className="text-gray-600">Be part of the Innovation.</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-6">
          {message && (
        <div className=" bg-green-100 border-l-4 border-green-500 text-green-700 p-4 rounded shadow-md animate-bounce">
          <CheckCircle className="inline-block mr-2" size={20} />
          <span>{message}</span>
        </div>
      )}
      {error && (
        <div className=" bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded shadow-md animate-bounce">
          <AlertCircle className="inline-block mr-2" size={20} />
          <span>{error}</span>
        </div>
      )}
            {[
              { name: 'name', icon: User, type: 'text', placeholder: 'Full Name' },
              { name: 'username', icon: AtSign, type: 'text', placeholder: 'Username', autoComplete: 'username' },
              { name: 'password', icon: Lock, type: showPassword ? 'text' : 'password', placeholder: 'Password',autoComplete: 'new-password' },
              { name: 'confirmPassword', icon: Lock, type: showPassword ? 'text' : 'password', placeholder: 'Confirm Password',autoComplete: 'new-password' },
            ].map((field) => (
              <div key={field.name} className="relative">
                <field.icon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
                <input
                  id={field.name}
                  name={field.name}
                  type={field.type}
                  value={formData[field.name]}
                  onChange={handleChange}
                  placeholder={field.placeholder}
                  autoComplete={field.autoComplete}
                  className="w-full pl-10 pr-3 py-2 border-b-2 border-gray-300 focus:outline-none focus:border-indigo-500 bg-transparent"
                />
                {errors[field.name] && <p className="mt-1 text-xs text-red-500">{errors[field.name]}</p>}
                {field.name.includes('password') && (
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2"
                  >
                    {showPassword ? <EyeOff size={18} className="text-gray-400" /> : <Eye size={18} className="text-gray-400" />}
                  </button>
                )}
              </div>
            ))}
            <button
              type="submit"
              disabled={isLoading}
              className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-custom-gradient hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-105"
            >
              {isLoading ? (
                <Loader className="animate-spin mr-2" size={20} />
              ) : (
                'Sign Up'
              )}
            </button>
          </form>
        </div>
        <div className="px-8 py-4 bg-gray-50 border-t border-gray-100 relative z-10">
          <p className="text-xs text-center text-gray-500">
            By clicking Sign Up, you agree to our{" "}
            <a href="#!" className="text-indigo-600 hover:text-indigo-500 transition duration-300 ease-in-out">
              Terms of Service
            </a>{" "}
            and{" "}
            <a href="#!" className="text-indigo-600 hover:text-indigo-500 transition duration-300 ease-in-out">
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </div>

    </div>
    <FooterSection/>

    </div>


  );
}
